module.exports = __webpack_public_path__ + "static/media/logisticproviders.e92aa77b.webp";